import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureMethodSelect} from '../../modules/gori-signature'

export default function GoriSignatureMethodSelectWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureMethodSelect />
    </PublicWrapper>
  )
}
